import { Card, createStyles, getStylesRef, Group, Stack } from '@mantine/core';
import type { IconNames } from '@repo/foundations';
import { Banner, ResourceIcon, Text } from '@repo/foundations';
import { transition } from '@repo/theme/primitives';
import { observer } from 'mobx-react-lite';

const useStyles = createStyles((theme) => ({
	titleGroup: {
		padding: 0,
		margin: 0,
		width: '100%',
		gap: theme.spacing.xs,
	},
	titleGroupContent: {
		ref: getStylesRef('titleGroupContent'),
		borderRadius: theme.radius.md,
		gap: theme.spacing.xs,
		padding: theme.spacing.xs,
	},
	card: {
		overflow: 'visible',
		border: `1px dashed ${theme.other.getColor('border/tertiary/default')}`,
		background: theme.other.getColor('surface/primary/default'),
		'&:hover': {
			background: theme.other.getColor('surface/primary/hover'),
			border: `1px dashed ${theme.other.getColor('border/tertiary/hover')}`,
			...transition('duration-100', 'easeIn')('background'),
		},
		[`&:hover .${getStylesRef('titleGroupContent')}`]: {
			background: theme.other.getColor('surface/secondary/hover'),
			...transition('duration-100', 'easeIn')('background'),
		},
		[`&:hover .${getStylesRef('titleGroupContent')} > div:first-child`]: {
			background: theme.other.getColor('fill/transparent-secondary/hover'),
			...transition('duration-100', 'easeIn')('background'),
		},
	},
}));

interface BlockPlaceholderProps {
	onClick: () => void;
	iconName: IconNames;
	title: string;
	bannerMessage: string;
}

export const BlockPlaceholder = observer(
	({ onClick, iconName, title, bannerMessage }: BlockPlaceholderProps) => {
		const { classes } = useStyles();

		return (
			<Card radius="md" p="xs" className={classes.card} onClick={onClick}>
				<Stack className={classes.titleGroup}>
					<Group className={classes.titleGroupContent}>
						<ResourceIcon iconName={iconName} />
						<Text size="sm" weight="semibold">
							{title}
						</Text>
					</Group>
					<Banner message={bannerMessage} tone="warning" inCard />
				</Stack>
			</Card>
		);
	}
);
